import { createContext, useContext } from 'react';

import { AppContextType } from 'context/types';

const AppContext = createContext(null);

export const useAppContext = (): AppContextType => useContext(AppContext);

export default AppContext;
